export const GET_POKEMONS = "GET_POKEMONS";
export const GET_POKEMON = "GET_POKEMON";
export const GET_POKEMONS_TYPES = "GET_POKEMONS_TYPES";

export const FIND_POKEMON_BY_NAME = "FIND_POKEMON_BY_NAME";

export const SELECT_POKEMON = "SELECT_POKEMON";

export const ADD_FAVORITE = "ADD_FAVORITE";
export const REMOVE_FAVORITE = "REMOVE_FAVORITE";

export const ADD_TO_FIGHT_LIST = "ADD_TO_FIGHT_LIST";
export const REMOVE_TO_FIGHT_LIST = "REMOVE_TO_FIGHT_LIST";

export const REQUEST_WITH_ERROR = "REQUEST_WITH_ERROR";
export const REQUESTING = "REQUESTING";
